import { Injectable, inject, signal } from '@angular/core';
import { Observable, of, tap } from 'rxjs';

import { listenWebsocketEvents } from '@core/websocket';

import {
  ApiResponse,
  Period,
  Prize,
  RainUser
} from './items-rain.entity';
import { ItemsRainService } from './items-rain.service';

@Injectable({
  providedIn: 'root'
})
export class ItemsRainState {
  private readonly itemsRainService = inject(ItemsRainService);

  public readonly period = signal<Period|null>(null);
  public readonly periodUsers = signal<RainUser[]>([]);
  public readonly historyPeriod = signal<Period|null>(null);
  public readonly myPlace = signal<Prize|null>(null);
  public readonly isInHistory = signal<boolean>(false);
  public readonly initialized = signal<boolean>(false);

  // TODO this can last forever, check if it works correct
  private readonly wsEvents = listenWebsocketEvents({
    'items_rain.period': (data) => this.onWsNewPeriod(data),
    'items_rain.update_users': (data) => this.onWsUpdateUsers(data)
    // 'items_rain.ensure_timer': (data) => this.onWsEnsureTimer(data)
  }, 'items_rain');

  setPeriod(period: Period|null): void {
    this.period.set(period);
    this.periodUsers.set(period?.users || []);
    this.initialized.set(true);
  }

  toggleHistory(): Observable<ApiResponse.PreviousPeriod|null> {
    this.isInHistory.update((isInHistory) => !isInHistory);

    if(!this.isInHistory()) {
      return of(null);
    }

    return this.itemsRainService.getPreviousPeriod().pipe(
      tap((response: ApiResponse.PreviousPeriod) => {
        this.historyPeriod.set(response.period);
      })
    );
  }

  loadMyPlace(): Observable<ApiResponse.MyPlace> {
    return this.itemsRainService.getMyPlace().pipe(
      tap((response: ApiResponse.MyPlace) => {
        this.myPlace.set(response.rainUser);
      })
    );
  }

  reset(): void {
    this.period.set(null);
    this.historyPeriod.set(null);
    this.myPlace.set(null);
  }

  private onWsNewPeriod(period: Period): void {
    this.period.set(period);
  }

  private onWsUpdateUsers(users: RainUser[]): void {
    const period = this.period();

    if(!period) {
      return;
    }

    this.periodUsers.set(users);
  }

  // private onWsEnsureTimer(timer: number): void {
  // }
}